import useLockBodyScroll from 'util/hook/useLockBodyScroll';

const ScrollLocker = () => {
	useLockBodyScroll();
	return null;
};

export default ScrollLocker;
